import { Channel } from './Channel';

/**
 * Diese Klasse verwaltet die Channels. Dabei werden bei
 * einer automatischen neuen Verbindung ein neuer Channel erstellt.
 */
export class ChannelManager {
	static EventSyn = 'ChannelManager.Syn';
	static EventSynAck = 'ChannelManager.SynAck';

	/**
	 * Verwaltet die Channels zwischen dem Pardot-IFrame und dem Top-Frame.
	 */
	constructor() {
		this.channels = new WeakMap();

		window.addEventListener('message', this.onMessage.bind(this), false);
	}

	/**
	 * Diese Funktion gibt anhand eines Target-Windows den passenden Channel zurück.
	 * Sollte noch kein Channel hinter dem Target existieren, wird eines erstellt,
	 * und dieser zurückgegeben.
	 *
	 * @param {Window} target Der Target-Window.
	 * @return {Channel} Hinter dem Target hinterlegter Channel.
	 */
	connect(target) {
		if (this.channels.has(target)) {
			let channel = this.channels.get(target);
			return channel;
		}

		let channel = new Channel();
		this.channels.set(target, channel);

		target.postMessage(
			{
				type: ChannelManager.EventSyn
			},
			'*'
		);

		return channel;
	}

	/**
	 * Diese Funktion fängt jede Nachricht ab und verarbeitet diese entsprechend.
	 *
	 * @param {Event} event
	 */
	onMessage(event) {
		let type = event?.data?.type ?? '';

		if (type === ChannelManager.EventSyn) {
			this.onConnectSyn(event);
		} else if (type === ChannelManager.EventSynAck) {
			this.onConnectAck(event);
		}
	}

	/**
	 * Diese Funktion wird aufgerufen, wenn der Partner versucht eine neue
	 * Verbindung aufzubauen. Hierbei muss der Partner eine Nachricht mit
	 * Typ "ChannelManager.EventSyn" senden.
	 *
	 * @param {Event} event
	 */
	onConnectSyn(event) {
		let target  = event.source;
		let channel = null;
		if (this.channels.has(target)) {
			channel = this.channels.get(target);
		} else {
			channel = new Channel();
			this.channels.set(target, channel);
		}

		let messageChannel = new MessageChannel();

		target.postMessage(
			{
				type: ChannelManager.EventSynAck
			},
			'*',
			[messageChannel.port2]
		);

		channel.start(messageChannel.port1);
	}

	/**
	 * Diese Funktion wird aufgerufen, wenn eine neue generelle Nachricht
	 * auf dem aktuellen Window ankommt. Wenn diese vom Typ "ChannelManager.init"
	 * ist, wird eine neue Verbindung aufgebaut.
	 *
	 * @param {Event} event
	 */
	onConnectAck(event) {
		let target  = event.source;
		let port    = event.ports[0];
		let channel = this.channels.get(target);

		channel.start(port);
	}
}
